import React from 'react';
import { CheckCircle, Clock, Play } from 'lucide-react';

interface SessionStatusBadgeProps {
  status: 'not_started' | 'in_progress' | 'completed';
  completionPercentage?: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SessionStatusBadge: React.FC<SessionStatusBadgeProps> = ({
  status,
  completionPercentage = 0,
  className = '',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const getStatusConfig = () => {
    switch (status) {
      case 'completed':
        return {
          label: 'Completed',
          icon: CheckCircle,
          bgColor: 'bg-muted-purple/10',
          textColor: 'text-muted-purple',
          borderColor: 'border-muted-purple/30',
          iconColor: 'text-muted-purple'
        };
      case 'in_progress':
        return {
          label: `${completionPercentage}% Complete`,
          icon: Clock,
          bgColor: 'bg-vibrant-orange/10',
          textColor: 'text-vibrant-orange',
          borderColor: 'border-vibrant-orange/30',
          iconColor: 'text-vibrant-orange'
        };
      default: // not_started
        return {
          label: 'Not Started',
          icon: Play,
          bgColor: 'bg-surface-muted/10',
          textColor: 'text-surface-muted',
          borderColor: 'border-surface-muted/30',
          iconColor: 'text-surface-muted'
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <div className={`
      inline-flex items-center space-x-1.5 rounded-full border font-medium
      ${sizeClasses[size]}
      ${config.bgColor}
      ${config.textColor}
      ${config.borderColor}
      ${className}
    `}>
      <Icon className={`${iconSizes[size]} ${config.iconColor}`} />
      <span>{config.label}</span>
    </div>
  );
};

export default SessionStatusBadge; 